/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityFullTranslationResponse } from '../../models/activity-full-translation-response';

export interface GetActivityFullTranslation$Params {
  id: number;
  fromCulture: string;
  toCulture: string;
}

export function getActivityFullTranslation(http: HttpClient, rootUrl: string, params: GetActivityFullTranslation$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityFullTranslationResponse>> {
  const rb = new RequestBuilder(rootUrl, getActivityFullTranslation.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('fromCulture', params.fromCulture, {});
    rb.query('toCulture', params.toCulture, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActivityFullTranslationResponse>;
    })
  );
}

getActivityFullTranslation.PATH = '/api/activities/{id}/translation/full';
